import * as React from 'react';
import * as styles from './PageBlock.css';

export const PageBlock: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['block']}>{children}</div>;
};
